import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  validate(event) {
    if (Number(this.element.dataset.pendingUploads || 0) > 0) {
      event.preventDefault()
      alert("파일 업로드가 끝날 때까지 기다려주세요.")
    }
  }
}
